module.exports = __webpack_public_path__ + "static/aws-db91b7f8f95dc64b2a8d9c4b4037f6e8.png";